import React, { useEffect } from 'react';
import MachineHero from '../components/home/MachineHero';
import LogoCloud from '../components/home/LogoCloud';
import VisionCarousel from '../components/home/VisionCarousel';
import ServicesGrid from '../components/home/ServicesGrid';
import FeaturesProcess from '../components/home/FeaturesProcess';
import PortfolioSection from '../components/home/PortfolioSection';
import MetricsSection from '../components/home/MetricsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQ from '../components/FAQ';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full">
      <MachineHero />
      <LogoCloud />
      <VisionCarousel />
      <PortfolioSection />
      <ServicesGrid />
      <FeaturesProcess />
      <MetricsSection />
      <TestimonialsSection />
      <FAQ />
    </div>
  );
};

export default Home;